import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { MessageService } from "@shared/services/message.service";

@Component({
  selector: "db-form-field-crud-controls",
  templateUrl: "./form-field-crud-controls.component.html",
  styleUrls: ["./form-field-crud-controls.component.scss"],
})
export class FormFieldCrudControlsComponent implements OnInit {
  @Input() showViewFieldControl: boolean;
  @Input() fieldId: string;

  @Output() viewFieldClick = new EventEmitter<any>();
  @Output() editFieldClick = new EventEmitter<any>();
  @Output() deleteFieldClick = new EventEmitter<any>();
  @Output() editGuidanceNotesclick = new EventEmitter<any>();
  @Output() viewGuidanceNotesclick = new EventEmitter<any>();

  constructor(private messageService: MessageService) {}

  ngOnInit() {}

  viewFieldClicked($event) {
    this.viewFieldClick.emit($event);
  }

  editFieldClicked($event) {
    this.editFieldClick.emit($event);
  }

  deleteFieldClicked($event) {
    this.deleteFieldClick.emit($event);
  }

  insertFieldClicked() {
    this.messageService.sendMessage("insert:" + this.fieldId);
  }
}
